import React from 'react';
import { Box } from '@chakra-ui/react';
import { Helmet } from 'react-helmet-async';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Skills } from './components/Skills';
import { Services } from './components/Services';
import { Projects } from './components/Projects';
import { Achievements } from './components/Achievements';
import { Testimonials } from './components/Testimonials';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { BackgroundScene } from './components/3DBackground';
export function App() {
  return <Box width="100%" minHeight="100vh" position="relative" data-id="element-0">
      <Helmet data-id="element-1">
        <title data-id="element-2">George Klenam</title>
        <meta name="description" content="Backend Developer & Security Specialist" data-id="element-3" />
      </Helmet>
      <BackgroundScene data-id="element-4" />
      <Box position="relative" zIndex="1" data-id="element-5">
        <Header data-id="element-6" />
        <Hero data-id="element-7" />
        <About data-id="element-8" />
        <Skills data-id="element-9" />
        <Services data-id="element-10" />
        <Projects data-id="element-11" />
        <Achievements data-id="element-12" />
        <Testimonials data-id="element-13" />
        <Contact data-id="element-14" />
        <Footer data-id="element-15" />
      </Box>
    </Box>;
}